import React, { useState, memo, useEffect } from "react";
import AccessControl from "../../../../shared/components/AccessControl";
import DataTable from "../../../../shared/components/DataTable";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    Card,
    CardBody,
    Col,
    ButtonToolbar,
    Badge,
    // UncontrolledPopover, PopoverHeader, PopoverBody
} from "reactstrap";
import { MdModeEdit, MdInsertDriveFile } from "react-icons/md";
import CustomSearch from "./CustomSearch";
import { reset } from "redux-form";
import Tabs from "../../../../shared/components/Tab/Tabs";
import "../../../../shared/components/Tab/tab.css";
import { permissionsConstants } from "../../../../constants/permission.constants";
// import { MdMoreVert, MdDeleteForever, MdBorderColor, MdToll } from "react-icons/md";

const { VIEW_INSTITUTIONS, MANAGE_INSTITUTIONS } = permissionsConstants;
const InstitutionTable = memo((props) => {
    const { dataState, fetchData, institutions, dispatch, permissions } = props;
    const [searchKey, setSearchKey] = useState("");
    const [filteredStore, setFilteredStore] = useState("");
    const [activeCount, setActiveCount] = useState(0);
    const [inactiveCount, setInactiveCount] = useState(0);
    const [currentTab, setCurrentTab] = useState(0);

    const count = dataState?.response?.count || 0;
    const data = dataState?.response?.content;
    useEffect(() => {
        if (count > 0) {
            const active = data.filter((x) => x.enabled);
            setActiveCount(active.length);
            setInactiveCount(data.length - active.length);
        }
    }, [data]);
    useEffect(() => {
        if (currentTab === 0 && count > 0) {
            setFilteredStore([...data]);
        } else if (currentTab === 1) {
            const active = data.filter((x) => x.enabled);
            setFilteredStore([...active]);
        } else if (currentTab === 2) {
            const inactive = data.filter((x) => !x.enabled);
            setFilteredStore([...inactive]);
        }
    }, [currentTab, data]);

    const handleSubmit = (values) => {
        setSearchKey(values.searchWord);
        fetchData({
            pageNum: 1,
            pageSize: 10,
            searchKey: values.searchWord || "",
        });
    };
    const loadData = (pageNum, pageSize) => {
        fetchData({
            ...dataState.request,
            pageNum,
            pageSize,
            searchWord: searchKey,
        });
    };
    const clearForm = () => {
        dispatch(reset("custom_search"));
        setSearchKey("");
    };
    const handleAction = (row, action) => {
        if (action.name === "view_institution") {
            props.history.push(`${props.location.pathname}/view/${row.id}`);
        } else if (action.name === "edit_institution") {
            props.history.push(`${props.location.pathname}/edit/${row.id}`);
        }
    };
    const actions = [
        {
            name: "view_institution",
            btnText: "View",
            btnAction: handleAction,
            btnClass: "success",
            btnIcon: MdInsertDriveFile,
            permissions: [VIEW_INSTITUTIONS],
            showButton: false,
        },
        {
            name: "edit_institution",
            btnText: "Edit",
            btnAction: handleAction,
            btnClass: "default",
            btnIcon: MdModeEdit,
            permissions: [MANAGE_INSTITUTIONS ],
            showButton: false,
        },
    ];
    const columns = [
        {
            accessor: "name",
            name: "Institution Name",
            filterable: true,
            show: true,
            Cell: (row) => <span>{row.name}</span>,
            permissions: "ROLE_VIEW_INSTITUTION",
        },
        {
            accessor: "code",
            name: "Fep Code",
            filterable: true,
            show: true,
            Cell: (row) => <span>{row.fepCode}</span>,
            permissions: "ROLE_VIEW_INSTITUTION",
        },
        {
            accessor: "domainCode",
            name: "Domain Code",
            filterable: true,
            show: true,
            Cell: (row) => <span>{row.domainCode}</span>,
            permissions: "ROLE_VIEW_INSTITUTION",
        },
        {
            accessor: "createdBy",
            name: "Created By",
            filterable: true,
            show: true,
            Cell: (row) => <span>{row.createdBy}</span>,
            permissions: "ROLE_VIEW_INSTITUTION",
        },
        {
            accessor: "createdOn",
            name: "Created On",
            filterable: true,
            show: true,
            Cell: (row) => <span>{row.createdOn}</span>,
            permissions: "ROLE_VIEW_INSTITUTION",
        },
        {
            accessor: "status",
            name: "Status",
            sortable: true,
            sortKey: "status",
            filterable: true,
            show: true,
            Cell: (row) => <Badge color={row.enabled ? "success" : "danger"}>{row.enabled ? "Enabled" : "Disabled"}</Badge>,
            permissions: "ROLE_MANAGE_INSTITUTION",
        },
    ];
    const onTabChange = (index, value) => {
        setCurrentTab(value);
    };

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <AccessControl allowedPermissions={[MANAGE_INSTITUTIONS]} renderNoAccess={() => null}>
                            <ButtonToolbar className="products-list__btn-toolbar-top">
                                <Link className="btn btn-primary products-list__btn-add" to="/institution/add" id="link-create-user" style={{ width: "12rem" }}>
                                    Add Institution
                                </Link>
                            </ButtonToolbar>
                        </AccessControl>
                    </div>
                    <br />
                    <DataTable
                        columns={columns}
                        loading={dataState && dataState.loading}
                        data={filteredStore.length ? filteredStore : []}
                        countName="Institution(s)"
                        count={count}
                        defaultPageSize={10}
                        clearSearch={clearForm}
                        defaultPageNumber={1}
                        loadData={loadData}
                        error={dataState && dataState.error}
                        permissions={permissions}
                        bordered={true}
                        striped={true}
                        hover={true}
                        actions={actions}
                        responsive
                        tableName="institution"
                        customSearch={
                            <div>
                                <CustomSearch
                                    pageNumer={1}
                                    initialValues={{
                                        pageNum: 1,
                                        pageSize: 10,
                                        searchKey: "",
                                    }}
                                    pageSize={10}
                                    onSubmit={handleSubmit}
                                    placeholder="Search"
                                />
                                {/* <Tabs onChange={onTabChange}>
                                    <div value="ALL" label={`All`}></div>
                                    <div value="ACTIVE" label={`Active`}></div>
                                    <div value="INACTIVE" label={`Inactive`}></div>
                                </Tabs> */}
                                <br />
                            </div>
                        }
                        searchKey={searchKey}
                        serverside
                    />
                </CardBody>
            </Card>
        </Col>
    );
});

export default connect((state) => ({
    institutions: state.getInstitutions,
    permissions: state.permissions && state.permissions.response,
}))(withRouter(InstitutionTable));
